// extracted by mini-css-extract-plugin
export var container = "_mw-0";
export var dotAnimation = "_mw-2";
export var dotsLoading = "_mw-1";